import axios from 'axios';
import router from '@/router';
import { useAuthStore } from '@/stores';

export default function setup() {
    axios.interceptors.request.use((config) => {
        const authStore = useAuthStore();
        const token = authStore.authToken;

        if (import.meta.env.VUE_APP_CLOUDFLARE_ID && import.meta.env.VUE_APP_CLOUDFLARE_SECRET) {
            config.headers['CF-Access-Client-Id'] = import.meta.env.VUE_APP_CLOUDFLARE_ID;
            config.headers['CF-Access-Client-Secret'] = import.meta.env.VUE_APP_CLOUDFLARE_SECRET;
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        config.headers['X-API-Key'] = 'bestelsite';
        return config;
    });

    axios.interceptors.response.use((res) => res, (err) => {
        if (err && err.response && err.response.status === 401) {
            useAuthStore().logout().then(() => router.push({ name: 'Login' }));
        }

        return Promise.reject(err);
    });
}
